module.exports = __webpack_public_path__ + "img/phone.b249e510.png";